import React, { useEffect, useState } from 'react';
import { userAppData } from '../MainApp.js';
import './OnCallPendingCall.css';
import { epochToReadableTime, SEC_DataApiPost } from '../func.js';
import { CgSpinner } from 'react-icons/cg';
import { getReadableTextColourForBackground } from './OnCallFunc.js';




export function OnCallPendingCall(props) {
    //permissions states
    const [allowManageCallsState, setAllowManageCallsState] = useState(false);

    const [, setPostApiErrorState] = useState(false);
    const [callUpdatingState, setCallUpdatingState] = useState(false);

    useEffect(() => {
        setAllowManageCallsState(userAppData['onCall']['allowManageCalls']);
    }, []);

    async function updateCallApiCall() {
        if (callUpdatingState) {
            return;
        }

        setCallUpdatingState(true);
        let formData = {
            "id": props.data['id']
        };
        let url = 'oncall/updateCall/accept';
        try {
            await SEC_DataApiPost(url, formData, formData, setPostApiErrorState);
            const acceptedCall = { ...props.data, isAcknowledged: true };

            if (typeof props.onPendingCallAccepted === 'function') {
                props.onPendingCallAccepted(acceptedCall);
            } else {
                props.apiCall({});
            }
        } catch (e) {
            console.log(e);
            setCallUpdatingState(false);
        }

    };

    const callTypeName = props.data['callTypeName'] || 'Unknown Type';
    const callTypeColour = props.data['callTypeColour'] || '#f2f2f2';
    const callTypeTextColour = props.data['callTypeFontColour'] || getReadableTextColourForBackground(callTypeColour);
    const callTypeCardStyle = {
        backgroundColor: callTypeColour,
        '--oncall-type-text-colour': callTypeTextColour
    };

    // change div to UPDATING.. as soon as clicked to signal its working and prevent multiple api calls from over clicking.
    if (allowManageCallsState) {
        return (
        <div
            className='oncall_pendingCall'
            style={callTypeCardStyle}
            aria-busy={callUpdatingState}
        >
            <div className='oncall_pendingCall_content'>
                <p className='oncall_pendingCall_text'>ID: {props.data['id']}</p>
                <p className='oncall_pendingCall_text'>{props.data['pupilId']}</p>
                <p className='oncall_pendingCall_text'>{callTypeName}</p>
                <p className='oncall_pendingCall_text'>{epochToReadableTime(props.data['submissionEpoch'])}</p>
            </div>
            <button
                type='button'
                className='oncall_pendingCall_acceptButton'
                onClick={updateCallApiCall}
                disabled={callUpdatingState}
            >
                {callUpdatingState ? (
                    <CgSpinner className='oncall_pendingCall_acceptSpinner' aria-label='Accepting pending call' />
                ) : (
                    'Accept'
                )}
            </button>
        </div>
    )
        } else {
            return (
                <div className='oncall_pendingCall_basic' style={callTypeCardStyle}>
                    <p className='oncall_pendingCall_text'>ID: {props.data['id']}</p>
                    <p className='oncall_pendingCall_text_basic'>{props.data['pupilId']}</p>
                    <p className='oncall_pendingCall_text_basic'>{callTypeName}</p>
                    <p className='oncall_pendingCall_text_basic'>{epochToReadableTime(props.data['submissionEpoch'])}</p>
                </div>
            )
        }
};
